import { render, staticRenderFns } from "./ChatsMessageTemplates.vue?vue&type=template&id=ba7ef106"
import script from "./ChatsMessageTemplates.vue?vue&type=script&lang=js"
export * from "./ChatsMessageTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports